import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconCheckBlue.module.css';

const IconCheckBlue = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    // <svg className={classes} width="26" height="37" viewBox="0 0 26 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <svg style={{ width: '2em' }} width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="50" fill="#2552e7" />
      <path d="M30 50 L45 65 L70 35" stroke="white" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

IconCheckBlue.defaultProps = { className: null };

IconCheckBlue.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconCheckBlue;
